import turf from 'turf'
import { defaultRadiusToHideTheSearchButton } from '../config'
require('@turf/distance')

export const withinSearchRadius = (searchCenter, center) => {
  const to = turf.point(searchCenter)
  const from = turf.point(center)
  const diff = turf.distance(from, to) * 3280.8 // convert to ft
  if (diff < defaultRadiusToHideTheSearchButton) {
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/withinSearchRadius.js